import { render, staticRenderFns } from "./OtherUserTabs.vue?vue&type=template&id=7a48e39c&scoped=true&"
import script from "./OtherUserTabs.vue?vue&type=script&lang=js&"
export * from "./OtherUserTabs.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserTabs.vue?vue&type=style&index=0&id=7a48e39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48e39c",
  null
  
)

export default component.exports